<!--客观题-->
<template>
	<div>
		<div class="drop-position" :style="concludeWH" ref="config">
			<vue-drag-resize
				ref="dragResize"
				class="mark-out-position"
				:class="rectItem.appendInfo ? 'pointer-active' : 'pointer-none'"
				v-for="(rectItem, rectIndex) in rectDetail"
				v-show="tempCurrentImgIndex.curIndex + 1 === Number(JSON.parse(rectItem.remarks).page)"
				:key="rectItem.pkId"
				:x="rectItem.areaMinX"
				:y="rectItem.areaMinY"
				:w="operateWidth(rectItem)"
				:h="operateHeight(rectItem)"
				:isActive="rectIndex === tempActiveArea"
				:isDraggable="rectIndex === tempActiveArea"
				:isResizable="rectIndex === tempActiveArea"
				@click.native="exitDrag"
				@resizestop="handleRectDragResize($event, rectIndex, rectItem)"
				@dragstop="handleRectDragResize($event, rectIndex, rectItem)"
				@mousedown="addRect($event, rectItem, rectIndex, rectItem.areaMinX, rectItem.areaMinY, rectItem.isTitle)"
			>
				<template>
					<div
						class="rect-title-wrap"
						v-if="!rectItem.isShowChild"
						@mousedown="addRect($event, rectItem, rectIndex, rectItem.areaMinX, rectItem.areaMinY, rectItem.isTitle)"
					>
						<vue-drag-resize
							class="mark-list"
							v-for="(item, index) in JSON.parse(rectItem.appendInfo).box"
							v-show="JSON.parse(rectItem.appendInfo).box && JSON.parse(rectItem.appendInfo).box.length > 0"
							:key="`${rectIndex}-${index}-rect`"
							:x="Number(item.x)"
							:y="Number(item.y)"
							:w="Number(item.w)"
							:h="Number(item.h)"
							:n="item.n"
							:isActive="false"
							:isResizable="false"
							:isDraggable="true"
							@dragstop="handleBoxDragResize($event, rectIndex, index, 'box')"
							@mousedown.native="handleRectClick($event, rectItem, item, rectIndex, index, false, 'box')"
						>
							<span class="mark-val" @mousedown="handleRectClick($event, rectItem, item, rectIndex, index, false, 'box')">{{ item.v }}</span>
						</vue-drag-resize>
						<vue-drag-resize
							class="mark-list mark-list-title"
							v-for="(item, index) in JSON.parse(rectItem.remarks).title"
							v-show="JSON.parse(rectItem.remarks).title && JSON.parse(rectItem.remarks).title.length > 0"
							:key="`${rectIndex}-${index}-title`"
							:x="Number(item.x)"
							:y="Number(item.y)"
							:w="Number(item.w) || 60"
							:h="Number(item.h) || 30"
							:isActive="false"
							:isDraggable="true"
							:isResizable="false"
							@dragstop="handleBoxDragResize($event, rectIndex, index, 'title')"
							@mousedown.native="handleRectClick($event, rectItem, item, rectIndex, index, true, 'title')"
						>
							<span class="mark-val" @mousedown="handleRectClick($event, rectItem, item, rectIndex, index, true, 'title')">{{ item.v }}</span>
						</vue-drag-resize>
					</div>
					<span class="rect-num obj-rect-num" v-show="rectItem.pkId">{{ `（${rectIndex + 1}/${rectDetail.length}）` }}</span>
					<i class="iconfont iconlajitong1 del-icon" v-show="rectItem.pkId" @click="dropArea({ val: rectItem, state: true })" title="删除"></i>
					<i class="iconfont iconfuzhi" v-show="rectItem.pkId" @click="copyRect({ val: rectItem, curIndex: rectIndex })" title="复制"></i>
					<div class="drop-menu drop-menu-obj" v-show="rectItem.pkId" title="更多操作">
						<el-dropdown class="el-dropdown-link" @command="dropDownMenu($event, { val: rectItem, curIndex: rectIndex })">
							<i class="iconfont iconjiantou-down"></i>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="drag">拖拽选区</el-dropdown-item>
								<el-dropdown-item command="rotate">旋转选区</el-dropdown-item>
								<el-dropdown-item command="setRow" v-show="JSON.parse(rectItem.remarks).version">设置行数</el-dropdown-item>
								<el-dropdown-item command="init" v-show="JSON.parse(rectItem.remarks).version">初始题号</el-dropdown-item>
								<el-dropdown-item command="completeCopy" v-show="JSON.parse(rectItem.remarks).version">完成复制</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</template>
			</vue-drag-resize>
		</div>
		<portal to="ope-dialog">
			<div class="recognise-wrap">
				<div class="recognise-my-no">
					<div class="my-reco-wrap" ref="myRecognise">
						<img :src="clipImg" alt="" style="max-width: 100%" ref="myRecogniseImg" />
						<vue-drag-resize
							class="my-recognise-wrap"
							:class="{ 'my-recognise-wrap-active': handleActive }"
							:x="resizeDragVal.left"
							:y="resizeDragVal.top"
							:w="resizeDragVal.width || 10"
							:h="resizeDragVal.height || 10"
							:isActive="isRecogniseDo"
							:isDraggable="isRecogniseDo"
							:isResizable="isRecogniseDo"
							@clicked="activeHandleRect"
							@resizestop="resizestop(resizeDragVal, $event)"
							@dragstop="dragstop"
						>
							<template>
								<vue-drag-resize
									class="my-recognise-rect"
									v-for="(item, index) in resultObjBox"
									:key="index"
									:x="item.x"
									:y="item.y"
									:w="item.w"
									:h="item.h"
									:curIndex="index"
									:isActive="false"
									:isResizable="false"
									:isDraggable="true"
									@dragstopIndex="rectDragStopIndex"
								>
									{{ item.v }}
								</vue-drag-resize>
							</template>
						</vue-drag-resize>
					</div>
				</div>
				<div class="recognise-obj-handle">
					<el-form ref="form" :model="opeObjForm" label-width="40px">
						<el-form-item label="行数">
							<step :defaultVal="opeObjForm.rowNum" key="rowNum" @stepVal="rowNumStepVal($event, 'rowNum')"></step>
						</el-form-item>
						<el-form-item label="列数">
							<step :defaultVal="opeObjForm.colNum" key="rowNum" @stepVal="rowNumStepVal($event, 'colNum')"></step>
						</el-form-item>
						<el-form-item label="宽度">
							<step :defaultVal="opeObjForm.width" key="rowNum" @stepVal="rowNumStepVal($event, 'width')"></step>
						</el-form-item>
						<el-form-item label="高度">
							<step :defaultVal="opeObjForm.height" key="rowNum" @stepVal="rowNumStepVal($event, 'height')"></step>
						</el-form-item>
					</el-form>
					<el-button class="wid100 marTop30 greenBg" style="margin-left: 10px" @click="verticalClockwiseRotationDown">竖直向下旋转</el-button>
					<el-button class="wid100 marTop30 greenBg" @click="verticalUnClockwiseRotationUp">竖直向上旋转</el-button>
					<el-button class="wid100 marTop30 greenBg" @click="horizontalClockwiseRotationRight">水平向右旋转</el-button>
					<el-button class="wid100 marTop30 greenBg" @click="horizontalClockwiseRotationLeft">水平向左旋转</el-button>
					<el-button class="wid100 marTop30" type="primary" @click="save">保存</el-button>
					<el-button class="wid100 marTop30" type="primary" @click="generateObjective">预览</el-button>
					<el-button class="wid100 marTop30" type="primary" @click="backRecognise">返回</el-button>
				</div>
			</div>
		</portal>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import VueDragResize from 'vue-drag-resize'
import isDragResize from '@/views/template-configuration/utils/mixin/is-drag-resize'
import drawRect from '@/views/template-configuration/utils/mixin/draw-rect'
import fixWH from '@/views/template-configuration/utils/mixin/fix-wh'
import fixRect from '@/views/template-configuration/utils/mixin/fix-rect'
import objectiveHandle from '../utils/mixin/objective-handle'
export default {
	name: 'subject',
	mixins: [fixRect, drawRect, fixWH, isDragResize, objectiveHandle],
	components: {
		VueDragResize,
		step: () => import('../utils/component/step')
	},
	data() {
		return {
			//所有框子
			rectDetail: [],
			//no use
			rectTitleDetail: [],
			//type
			emitType: 'tempRectObjective',
			query: this.$route.query,
			//no use
			colNum: 0,
			//no use
			resultArrBox: [],
			//当前的试卷
			currentImg: '',
			//选择题的排列方向  横向还是竖向、
			objDirection: 'V',
			//选指责提题号
			boxTitle: null,
			//当前激活的框子
			rectIndex: 0,
			//框子的是
			boxIndex: [],
			objectiveActiveIndex: [],
			handleActive: false,
			//初始题号
			initHandleTopic: 0,
			//题号
			handleTitle: [],
			keyFlag: true
		}
	},
	watch: {
		tempObjTopic: {
			handler() {
				this.initHandleTopic = 0
			},
			immediate: true,
			deep: true
		},
		tempInitObjTopic: {
			handler() {
				this.initHandleTopic = 0
				console.log('111111')
			},
			immediate: true,
			deep: true
		},
		tempRowNum(val) {
			console.log(val)
		}
	},
	computed: {
		...mapGetters('examination/configation', [
			'tempRowNum',
			'tempObjDirection',
			'tempRectObjective',
			'tempObjTopic',
			'tempTopicCurrentIndex',
			'tempCurrentImgIndex',
			'handHandleState',
			'objCanKeyDel',
			'tempInitObjTopic',
			'tempFillDirection'
		])
	},
	filters: {
		filterTitle(val) {
			if (val.m) {
				return val.m.split('.')[1]
			} else {
				return ''
			}
		}
	},
	mounted() {
		const _this = this
		document.onkeydown = function(event) {
			_this.objDelCtrlKeys(event)
			_this.objUpDownKeys(event)
			_this.handleHandMove(event)
		}
		this.eventBus.$on('setTempRowNum', cb => {
			this.refreshPpi(cb)
		})
	},
	methods: {
		...mapActions('examination/databases', ['set', 'get']),
		...mapMutations('examination/configation', ['setTempObjDirection', 'setTempRectObjective', 'setTempTopicCurrentIndex', 'setObjCanKeyDel']),
		handleRectDragResize(e, index, val) {
			let isDone = false
			let total = 0
			cloneDeep(this.tempObjTopic).forEach(res => {
				res.val.forEach(ele => (total += ele.num))
			})
			if (JSON.parse(val.appendInfo).box.length === total) isDone = true
			this.setTempTopicCurrentIndex(index)
			this.rectDragResize(e, index, isDone)
		},
		// icon 复制
		copyRect(commandVal) {
			this.dropDownMenu('copy', commandVal)
		},
		//del 键实现删除
		objDelCtrlKeys(e) {
			const _this = this
			if (!this.objCanKeyDel) this.$message.error('请等待删除完成')
			if (e.keyCode === 46 && !_this.handHandleState && this.tabActive === 'objective') {
				if (_this.rectIndex === null || _this.boxIndex.length === 0) return false
				_this.setObjCanKeyDel(false)
				let rectDetail = cloneDeep(_this.rectDetail[_this.rectIndex])
				let appendInfo = JSON.parse(rectDetail.appendInfo)
				let box = appendInfo.box
				let resArrBox = []
				box.forEach(resp => {
					let resStr = `${resp.n}-${resp.x}-${resp.y}`
					if (!this.objectiveActiveIndex.includes(resStr)) {
						resArrBox.push(resp)
					}
				})
				appendInfo.box = resArrBox
				rectDetail.appendInfo = JSON.stringify(appendInfo)
				_this.refreshPpi(rectDetail)
				_this.rectIndex = null
				_this.boxIndex = []
			}
		},
		// 已生成  上下左右  enter key
		objUpDownKeys(event) {
			if (
				this.tabActive === 'objective' &&
				!this.handHandleState &&
				this.objectiveActiveIndex.length !== 0 &&
				(event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40)
			) {
				event.preventDefault()
				let rectDetail = cloneDeep(this.rectDetail)
				let currentVal = rectDetail[this.rectIndex]
				let appendInfo = JSON.parse(currentVal.appendInfo)
				let box = appendInfo.box
				box.forEach((resp, index) => {
					let curVal = `${resp.x}-${resp.y}`
					if (this.objectiveActiveIndex.includes(curVal)) {
						if (event.keyCode === 37) box[index].x -= 1
						if (event.keyCode === 38) box[index].y -= 1
						if (event.keyCode === 39) box[index].x += 1
						if (event.keyCode === 40) box[index].y += 1
						let indexofs = this.objectiveActiveIndex.indexOf(curVal)
						this.objectiveActiveIndex[indexofs] = `${box[index].n}-${box[index].x}-${box[index].y}`
					}
				})
				appendInfo.box = box
				currentVal.appendInfo = JSON.stringify(appendInfo)
				rectDetail[this.rectIndex] = currentVal
				this.setTempRectObjective({ val: rectDetail, state: false })
				this.refreshPpi(currentVal, false)
			}
			return false
		},
		handleHandMove(event) {
			if (this.tabActive === 'objective' && this.handHandleState && this.handleActive) {
				if (event.keyCode === 37) this.resizeDragVal.left -= 1
				if (event.keyCode === 39) this.resizeDragVal.left += 1
				if (event.keyCode === 38) this.resizeDragVal.top -= 1
				if (event.keyCode === 40) this.resizeDragVal.top += 1
			}
		},
		// 更新Ppi
		refreshPpi(rectDetail, flush = true) {
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: this.tempEditImgInfo.versionId,
				ppiId: rectDetail['pkId'],
				ppiStr: JSON.stringify(rectDetail)
			}
			this.$post('Cv/refreshPpi', params).then(res => {
				if (res.code === 200) {
					if (flush) {
						this.objectiveActiveIndex = []
						this.setTempFlushData({ state: true })
						this.$message.success('成功')
					}
				}
			})
		},
		// 激活
		handleRectClick(event, rectItem, item, rectIndex, index, isTitle = false, type) {
			this.setTempTopicCurrentIndex(rectIndex)
			if (event.button === 0) {
				this.boxTitle = type
				this.rectIndex = rectIndex
				if (this.boxIndex.includes(index)) {
					let curIndex = this.boxIndex.indexOf(index)
					this.$delete(this.boxIndex, curIndex)
					this.$delete(this.objectiveActiveIndex, curIndex)
				} else {
					this.boxIndex.push(index)
					this.objectiveActiveIndex.push(`${item.n}-${item.x}-${item.y}`)
				}
			} else if (event.button === 2) {
				this.rectIndex = null
				this.boxIndex = []
				this.fixRectList(event, rectItem, item, rectIndex, index, isTitle)
			}
		},
		//拖拽 已生成的小框框
		handleBoxDragResize(event, rectIndex, index, type) {
			let rectDetail = cloneDeep(this.rectDetail[rectIndex])
			console.log(rectDetail)
			let appendInfo = JSON.parse(rectDetail.appendInfo)
			let box = appendInfo.box
			let remarks = JSON.parse(rectDetail.remarks)
			let title = remarks.title
			if (type === 'box') {
				if (Math.abs(box[index].x - event.left) < 2 && Math.abs(box[index].y - event.top) < 2) return false
				box[index].x = event.left
				box[index].y = event.top
			} else if (type === 'title') {
				if (Math.abs(box[index].x - event.left) < 2 && Math.abs(box[index].y - event.top) < 2) return false
				title[index].x = event.left
				title[index].y = event.top
			}
			appendInfo.box = box
			remarks.title = title
			rectDetail.appendInfo = JSON.stringify(appendInfo)
			rectDetail.remarks = JSON.stringify(remarks)
			this.refreshPpi(rectDetail)
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/css/mark-point.less';
</style>
